import { render, staticRenderFns } from "./TableQuestion.vue?vue&type=template&id=0671561e&scoped=true"
import script from "./TableQuestion.vue?vue&type=script&lang=js"
export * from "./TableQuestion.vue?vue&type=script&lang=js"
import style0 from "./TableQuestion.vue?vue&type=style&index=0&id=0671561e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0671561e",
  null
  
)

export default component.exports